(() => {
  const STYLE_KEY = 'sculpt-forms-border';
  const STYLE_ATTR = 'data-sculpt-forms-style';
  const stockistSection = document.querySelector('.section-stockist');

  const cssVar = (name, fallback) => {
    const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return value || fallback;
  };

  const btnDefaultBg = () => cssVar('--color-secondary-button-background', '#f8f9f5');
  const btnDefaultText = () => cssVar('--color-secondary-button-text', '#231f20');
  const btnHoverBg = () => cssVar('--color-secondary-button-hover-background', '#ede8de');
  const btnHoverText = () => cssVar('--color-secondary-button-hover-text', '#231f20');
  const foreground = () => cssVar('--color-foreground', '#231f20');

  /* CSS only for submit — no permanent element.style (blocks :hover) */
  const buildCss = () => `
    :host,
    :host(*) {
      --button-border-radius: 50px !important;
      --inline-container-max-width: 100% !important;
      width: 100% !important;
      max-width: 100% !important;
      display: block !important;
      box-sizing: border-box !important;
    }
    [data-testid="app-router"],
    [class*="_container_"],
    [class*="_fadeAnimation_"] {
      width: 100% !important;
      max-width: 100% !important;
      display: flex !important;
      flex-direction: column !important;
      align-items: stretch !important;
      justify-content: flex-start !important;
      justify-items: stretch !important;
      box-sizing: border-box !important;
    }
    @media screen and (max-width: 490px) {
      [data-testid="app-router"],
      [class*="_container_"],
      [class*="_fadeAnimation_"] {
        width: 100% !important;
        max-width: 100% !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: stretch !important;
        justify-content: flex-start !important;
        justify-items: stretch !important;
      }
    }
    :host > *,
    form,
    form[class*="_formFieldset_"],
    [class*="_formFieldset_"],
    [class*="_inline_"],
    [class*="_formContainer_"],
    [class*="_formBody_"],
    [class*="_gridItem_"],
    [class*="_formRow_"],
    [class*="_formFields_"],
    [class*="_stack_"],
    [class*="_column_"] {
      width: 100% !important;
      max-width: 100% !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
      justify-self: stretch !important;
      box-sizing: border-box !important;
    }
    *,
    button,
    button[type="submit"],
    [type="submit"],
    button[class*="_formSubmit"],
    button[data-testid="btn-form-submit"] {
      --button-border-radius: 50px !important;
    }
    input[class*="_formInputField_"],
    textarea[class*="_formInputField_"],
    select[class*="_formInputField_"],
    button[aria-haspopup="listbox"],
    [class*="Country"],
    [class*="country"] {
      box-shadow: none !important;
      --form-field-border: none;
    }
    input[class*="_formInputField_"]:not([class*="Phone"]):not([class*="phone"]),
    textarea[class*="_formInputField_"],
    select[class*="_formInputField_"]:not([class*="Phone"]):not([class*="phone"]) {
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box !important;
    }
    button[type="submit"],
    [type="submit"],
    button[class*="_formSubmit"],
    button[data-testid="btn-form-submit"] {
      --button-border-radius: 50px !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      text-align: center !important;
      width: 100% !important;
      max-width: 100% !important;
      min-height: 48px !important;
      padding: 12px 24px !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
      box-sizing: border-box !important;
      gap: 0 !important;
      background-color: ${btnDefaultBg()} !important;
      background-image: none !important;
      color: ${btnDefaultText()} !important;
      border-radius: 50px !important;
      border-radius: var(--button-border-radius, 50px) !important;
      line-height: 1.2 !important;
    }
    button[type="submit"] > *,
    [type="submit"] > *,
    button[class*="_formSubmit"] > *,
    button[data-testid="btn-form-submit"] > * {
      margin: 0 !important;
      position: static !important;
    }
    button[type="submit"]:hover,
    [type="submit"]:hover,
    button[class*="_formSubmit"]:hover,
    button[data-testid="btn-form-submit"]:hover {
      --button-border-radius: 50px !important;
      background-color: ${btnHoverBg()} !important;
      background-image: none !important;
      color: ${btnHoverText()} !important;
      border-radius: 50px !important;
      border-radius: var(--button-border-radius, 50px) !important;
    }
    /* File upload: force English label via CSS (Forms renders <span>, not <button>) */
    [class*="_formFileInputButton_"],
    button[class*="_formFileInputButton_"] {
      font-size: 0 !important;
      line-height: 0 !important;
    }
    [class*="_formFileInputButton_"]::after,
    button[class*="_formFileInputButton_"]::after {
      content: "Add file";
      font-size: 14px !important;
      line-height: 1.4 !important;
    }
    h2[class*="_textHeading_"],
    h2.h2 {
      font-family: 'Arapey', serif !important;
      font-size: 35px !important;
      font-weight: 400 !important;
      line-height: 1.25 !important;
      letter-spacing: -0.02em !important;
      text-align: center !important;
      color: ${foreground()} !important;
      margin: 0 0 36px !important;
    }
  `;

  const ensureFormStyles = () => {
    try {
      if (!(window.formStyles instanceof Map)) {
        window.formStyles = new Map();
      }
      window.formStyles.set(STYLE_KEY, buildCss());
    } catch (_) {
      /* ignore */
    }
  };

  const injectIntoShadow = (root) => {
    if (!root) return;
    const css = buildCss();

    let style = root.querySelector?.(`style[${STYLE_ATTR}]`);
    if (!style) {
      style = document.createElement('style');
      style.setAttribute(STYLE_ATTR, 'true');
      root.appendChild(style);
    }
    style.textContent = css;

    try {
      if (typeof CSSStyleSheet !== 'undefined' && root.adoptedStyleSheets) {
        const kept = [...root.adoptedStyleSheets].filter((sheet) => !sheet.__sculptForms);
        const sheet = new CSSStyleSheet();
        sheet.replaceSync(css);
        sheet.__sculptForms = true;
        root.adoptedStyleSheets = [...kept, sheet];
      }
    } catch (_) {
      /* style tag is enough */
    }
  };

  const clearInlineSubmitStyles = (el) => {
    if (!el) return;
    el.style.removeProperty('background');
    el.style.removeProperty('background-color');
    el.style.removeProperty('background-image');
    el.style.removeProperty('color');
    el.style.setProperty('--button-border-radius', '50px', 'important');
    el.style.setProperty('border-radius', '50px', 'important');
    delete el.dataset.sculptSubmitBound;
  };

  const applyHeadingStyle = (el) => {
    el.style.setProperty('font-family', "'Arapey', serif", 'important');
    el.style.setProperty('font-size', '35px', 'important');
    el.style.setProperty('font-weight', '400', 'important');
    el.style.setProperty('line-height', '1.25', 'important');
    el.style.setProperty('letter-spacing', '-0.02em', 'important');
    el.style.setProperty('text-align', 'center', 'important');
    el.style.setProperty('color', foreground(), 'important');
    el.style.setProperty('margin', '0 0 36px', 'important');
  };

  const isSubmit = (el) => {
    if (!el || el.nodeType !== 1) return false;
    if (!el.matches?.('button, [type="submit"], input[type="submit"]')) return false;
    const cls = String(el.className || '');
    const text = (el.textContent || '').trim().toLowerCase();
    return (
      el.type === 'submit' ||
      el.getAttribute('type') === 'submit' ||
      el.getAttribute('data-testid') === 'btn-form-submit' ||
      /_formSubmit|SubmitButton/i.test(cls) ||
      text === 'submit' ||
      text === 'send'
    );
  };

  const fromPath = (event, test) => {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    return path.find((node) => test(node)) || null;
  };

  const scopes = () => {
    const list = [];
    document.querySelectorAll('.section-apps, .payment-confirm__app, form-embed, shopify-forms-embed, [data-forms-id]').forEach((el) => {
      list.push(el);
    });
    return list;
  };

  const visitShadows = (node, roots) => {
    if (!node) return;
    if (node.shadowRoot) {
      roots.push(node.shadowRoot);
      visitShadows(node.shadowRoot, roots);
    }
    node.querySelectorAll?.('*').forEach((el) => {
      if (el.shadowRoot) {
        roots.push(el.shadowRoot);
        visitShadows(el.shadowRoot, roots);
      }
    });
  };

  const collectRoots = () => {
    const roots = [];
    scopes().forEach((scope) => visitShadows(scope, roots));
    return roots;
  };

  const isAddFileButton = (el) =>
    el?.matches?.('button[class*="_formFileInputButton_"], [class*="_formFileInputButton_"]');

  const normalizeAddFileButton = (el) => {
    if (!isAddFileButton(el)) return;

    const props = ['display', 'align-items', 'justify-content', 'width', 'max-width', 'min-height', 'padding', 'border-radius', 'box-sizing', 'line-height', 'text-align', 'font-size'];
    props.forEach((prop) => el.style.removeProperty(prop));

    const wrap = el.closest('[class*="file"], [class*="File"], [class*="upload"], [class*="Upload"], [class*="drop"]');
    if (wrap) {
      wrap.style.removeProperty('width');
      wrap.style.removeProperty('max-width');
      wrap.style.removeProperty('box-sizing');
    }
  };

  const forceFullWidth = (root) => {
    if (!root?.querySelectorAll) return;
    root.querySelectorAll('form, [data-testid="app-router"], [class*="_container_"], [class*="_formFieldset_"], [class*="_inline_"], [class*="_formContainer_"], [class*="_formBody_"], [class*="_gridItem_"]').forEach((el) => {
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('max-width', '100%', 'important');
      el.style.setProperty('margin-left', '0', 'important');
      el.style.setProperty('margin-right', '0', 'important');
      el.style.setProperty('box-sizing', 'border-box', 'important');
      el.style.setProperty('justify-self', 'stretch', 'important');
      if (el.matches('[data-testid="app-router"], [class*="_container_"]')) {
        el.style.setProperty('display', 'flex', 'important');
        el.style.setProperty('flex-direction', 'column', 'important');
        el.style.setProperty('align-items', 'stretch', 'important');
        el.style.setProperty('justify-content', 'flex-start', 'important');
        el.style.setProperty('justify-items', 'stretch', 'important');
      }
    });

    root.querySelectorAll('button').forEach((btn) => {
      if (isSubmit(btn)) {
        btn.style.setProperty('display', 'inline-flex', 'important');
        btn.style.setProperty('align-items', 'center', 'important');
        btn.style.setProperty('justify-content', 'center', 'important');
        btn.style.setProperty('text-align', 'center', 'important');
        btn.style.setProperty('width', '100%', 'important');
        btn.style.setProperty('box-sizing', 'border-box', 'important');
        return;
      }

      normalizeAddFileButton(btn);
    });

    /* Shopify Forms file picker label is a <span>, not a <button> */
    root.querySelectorAll('[class*="_formFileInputButton_"]').forEach(normalizeAddFileButton);
  };

  const scanTargets = () => {
    ensureFormStyles();

    document.querySelectorAll('form-embed, shopify-forms-embed, [data-forms-id]').forEach((host) => {
      host.style.setProperty('--button-border-radius', '50px');
      host.style.setProperty('--inline-container-max-width', '100%');
      host.style.setProperty('width', '100%');
      host.style.setProperty('max-width', '100%');
      host.style.setProperty('display', 'block');
      host.style.setProperty('box-sizing', 'border-box');
      forceFullWidth(host.shadowRoot);
    });

    collectRoots().forEach((root) => {
      injectIntoShadow(root);
      forceFullWidth(root);

      root.querySelectorAll('input, textarea, select, button').forEach((el) => {
        if (isSubmit(el)) clearInlineSubmitStyles(el);
        el.style.removeProperty('--form-field-border');
        el.style.removeProperty('box-shadow');
      });

      if (stockistSection) {
        root.querySelectorAll('h2[class*="_textHeading_"], h2.h2').forEach((el) => {
          if (el.dataset.sculptHeadingBound === 'true') return;
          el.dataset.sculptHeadingBound = 'true';
          applyHeadingStyle(el);
        });
      }
    });
  };

  /* Fallback hover only if CSS :hover loses — set then clear, never leave permanent style */
  const onEnter = (event) => {
    const submit = fromPath(event, isSubmit);
    if (!submit) return;
    submit.style.setProperty('background-color', btnHoverBg(), 'important');
    submit.style.setProperty('color', btnHoverText(), 'important');
  };

  const onLeave = (event) => {
    const submit = fromPath(event, isSubmit);
    if (!submit) return;
    clearInlineSubmitStyles(submit);
  };

  const start = () => {
    ensureFormStyles();
    scanTargets();

    document.addEventListener('pointerover', onEnter, true);
    document.addEventListener('pointerout', onLeave, true);

    if (window.MutationObserver) {
      const observer = new MutationObserver(() => {
        ensureFormStyles();
        scanTargets();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    [100, 300, 600, 1000, 2000, 4000].forEach((ms) => {
      setTimeout(() => {
        ensureFormStyles();
        scanTargets();
      }, ms);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
